export const error404Path = "/404"
export const errorUnauthorizedPath = "/unauthorized"
